/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} DisputeTimesheetDetailsClientType
 * @property {TimesheetAddedComment} details
 * @property {Date} submittedDateUtc - Date timesheet was submitted
 * @property {TimesheetModificationsViewModel} modifications - List of modifications changing the original booking times
 */

import TimesheetModificationsViewModel from './timesheetModificationsViewModel'
import DisputeTimesheetDetails from './disputeTimesheetDetails'
import TimesheetAddedComment from './timesheetAddedComment'

/**
 * @class
 */
export default class DisputeTimesheetDetailsClient extends DisputeTimesheetDetails {
  /**
   * Create a new DisputeTimesheetDetailsClient.
   * @param {DisputeTimesheetDetailsClientType} params
   */
  constructor(params) {
    super(params)
    this.details = params.details
      ? new TimesheetAddedComment(params.details)
      : null
  }
}
